import type { RouteObject } from "react-router";
import { CreatorEinladen } from "./CreatorEinladen";
import { CreatorListe } from "./CreatorListe";
import { CreatorProfil } from "./CreatorProfil";
import { StammdatenImport } from "./Import";
import { InsightsFreigeben } from "./InsightsFreigeben";
import { InsightsUebersicht } from "./InsightsUebersicht";
import { MarkenDetail } from "./MarkenDetail";
import { MarkenListe } from "./MarkenListe";
import { MediaKitSeite } from "./MediaKitSeite";
import { PitchListen } from "./PitchListen";
import { MeinProfil } from "../studio";

/** Creator & Marken (Stammdaten). Feste Wege stehen vor den Kennungs-Wegen; React Router bevorzugt sie ohnehin. */
export const stammdatenRoutes: RouteObject[] = [
  { path: "ich", element: <MeinProfil /> },
  { path: "creator", element: <CreatorListe /> },
  { path: "creator/einladen", element: <CreatorEinladen /> },
  { path: "creator/insights", element: <InsightsUebersicht /> },
  { path: "creator/import", element: <StammdatenImport kind="creator" /> },
  { path: "creator/pitch", element: <PitchListen /> },
  { path: "creator/:talentId", element: <CreatorProfil /> },
  { path: "creator/:talentId/insights", element: <InsightsFreigeben /> },
  { path: "creator/:talentId/mediakit", element: <MediaKitSeite /> },
  { path: "marken", element: <MarkenListe /> },
  { path: "marken/import", element: <StammdatenImport kind="marken" /> },
  { path: "marken/:brandId", element: <MarkenDetail /> },
];
